<template>
  <v-container fluid id="appSupportRequests" class="pa-0 pa-sm-3">
    <v-dialog v-model="viewDialog" max-width="600">
      <v-card v-if="currentItem">
        <v-card-title primary-title>
          App Support Request
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="pl-0">
                    <strong>Category</strong>
                  </td>
                  <td>
                    {{ currentItem.requestCategory }}
                  </td>
                </tr>
                <tr>
                  <td class="pl-0">
                    <strong>Subject</strong>
                  </td>
                  <td>
                    {{ currentItem.subject }}
                  </td>
                </tr>
                <tr>
                  <td class="pl-0">
                    <strong>Description</strong>
                  </td>
                  <td>
                    {{ currentItem.description }}
                  </td>
                </tr>
                <tr>
                  <td class="pl-0">
                    <strong>Notes</strong>
                  </td>
                  <td>
                    <div
                      v-for="note in currentItem.notes"
                      :key="note.createDate"
                      style="background: #f4f4f4;padding: 5px 8px;margin: 5px 0;border: solid 1px #cdcdcd;border-radius: 5px;"
                    >
                      {{ note.message }}<br />
                      <span class="caption grey--text">
                        <em>
                          {{ note.createdBy.name }} on
                          {{
                            note.createDate | moment("MMM D YYYY [at] h:mma")
                          }}</em
                        ></span
                      ><br />
                    </div>
                    <v-textarea
                      label="Add Note"
                      outlined
                      class="mt-2 mb-2"
                      hide-details
                      v-model="currentItem.message"
                      v-if="currentItem.status === 'open'"
                    ></v-textarea>
                    <v-btn
                      v-if="currentItem.status === 'open'"
                      color="primary"
                      small
                      @click="saveNote"
                      :disabled="!currentItem.message"
                      >Save Note</v-btn
                    >
                  </td>
                </tr>

                <tr v-if="currentItem.status === 'closed'">
                  <td class="pl-0">
                    <strong>Final Note</strong>
                  </td>
                  <td>
                    {{ currentItem.closingNote }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions class="align-right pa-4">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="viewDialog = false" class="mr-2"
            >cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cancelDialog" max-width="600">
      <v-card v-if="currentItem">
        <v-card-title primary-title>
          Cancel Support Request
        </v-card-title>
        <v-card-text>
          <strong>{{ currentItem.subject }}</strong
          ><br />
          {{ currentItem.description }}<br /><br />
          <span class="red--text"
            >Click submit button below to cancel the support request.</span
          >
        </v-card-text>
        <v-card-actions class="align-right pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="cancelDialog = false" class="mr-2">cancel</v-btn>
          <v-btn color="primary" @click="cancelRequest" class="mr-2"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row wrap>
      <v-col cols="12" xs="12" class="headline pb-0">
        App Support Requests
        <v-btn color="primary" small class="ml-4" to="/app-support/new"
          ><v-icon small left>add</v-icon> New</v-btn
        >
      </v-col>
      <v-col cols="12" xs="12" class="pb-0">
        <p>
          Submit app support requests for issues and suggestions related to the
          ALBA App.
        </p>
      </v-col>
      <v-col cols="12" xs="12" class="">
        <v-card>
          <v-tabs>
            <v-tab @click="appSupportRequestType('open')">Open</v-tab>
            <v-tab @click="appSupportRequestType('closed')">Closed</v-tab>
            <v-tab @click="appSupportRequestType('cancelled')">Cancelled</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="currentAppSupportRequests"
            :loading="loadingAppSupportRequests"
            loading-text="Loading....please wait."
            :headers="headers"
            disable-sort
          >
            <template v-slot:item.orderNumber="{ item }">
              <span class="subtitle-2">#{{ item.orderNumber }}</span>
            </template>
            <template v-slot:item.orderDate="{ item }">
              {{ item.orderDate.toDate() | moment("MMM Do, YYYY") }}
            </template>
            <template v-slot:item.status="{ item }">
              <status-chip :status="item.status" />
            </template>
            <template v-slot:item.notes="{ item }">
              <div v-for="(note, ix) in item.notes" :key="note.createDate">
                <div v-if="ix == item.notes.length - 1 && !item.closingNote">
                  {{ note.message }}
                  <span class="caption grey--text">
                    by {{ note.createdBy.name }} on
                    {{
                      note.createDate | moment("MMM D YYYY [at] h:mma")
                    }}</span
                  >
                </div>
              </div>
              <span v-if="item.closingNote">
                <v-icon small style="margin-top:-3px" class="mr-1"
                  >check_box</v-icon
                >{{ item.closingNote }}
              </span>
            </template>
            <template v-slot:item.view="{ item }">
              <v-btn
                color="primary"
                small
                outlined
                text
                class="mr-1"
                @click="openDialog(item, 'viewDialog')"
                >view</v-btn
              >
              <v-btn
                color="primary"
                small
                outlined
                text
                @click="openDialog(item, 'cancelDialog')"
                >cancel</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
import statusChip from "@/components/StatusChip";
import firebase from "firebase/app";
import moment from "moment";
export default {
  components: {
    statusChip,
  },
  data() {
    return {
      type: "open",
      loadingAppSupportRequests: true,
      appSupportRequests: [],
      currentItem: null,
      viewDialog: false,
      cancelDialog: false,
      headers: [
        {
          text: "",
          align: "left",
          value: "orderNumber",
          sortable: false,
          width: 60,
        },
        { text: "Category", value: "requestCategory", width: 140 },
        { text: "Subject", value: "subject" },
        { text: "Description", value: "description" },
        { text: "Latest Note", value: "notes" },
        { text: "Status", value: "status", align: "center", width: 100 },
        { text: "", value: "view", align: "right", width: 180 },
      ],
    };
  },
  computed: {
    currentAppSupportRequests: function() {
      return this.appSupportRequests.filter((wo) => wo.status == this.type);
    },
    ...mapState(["user"]),
  },
  async created() {
    this.getAppSupportRequests();
  },
  methods: {
    async getAppSupportRequests() {
      try {
        const appSupportRequests = await fb.db
          .collection("appSupportRequests")
          .where("orderedBy.uid", "==", this.user.uid)
          .orderBy("orderDate", "desc")
          .limit(300)
          .get();
        this.appSupportRequests = [];
        appSupportRequests.forEach((u) => {
          this.appSupportRequests.push({
            ...u.data(),
          });
        });
        this.loadingAppSupportRequests = false;
      } catch (error) {
        alert(error);
        console.log(error);
        this.loadingAppSupportRequests = false;
      }
    },
    appSupportRequestType(type) {
      this.type = type;
    },
    openDialog(item, dialog) {
      this.currentItem = item;
      this[dialog] = true;
    },
    async saveNote() {
      const payload = {
        message: this.currentItem.message,
        createdBy: {
          name: `${this.user.firstName} ${this.user.lastName}`,
          email: `${this.user.email}`,
        },
        createDate: moment().unix(),
      };
      await fb.db
        .collection("appSupportRequests")
        .doc(this.currentItem.orderNumber)
        .update({
          notes: firebase.firestore.FieldValue.arrayUnion(payload),
        });
      this.viewDialog = false;
      this.getAppSupportRequests();
      const appRequestNoteEmail = await fb.functions.httpsCallable(
        "appRequestNoteEmail"
      );
      console.log({
        ...payload,
        fromUser: true,
        request: this.currentItem,
      });
      appRequestNoteEmail({
        ...payload,
        fromUser: true,
        request: this.currentItem,
      });
    },
    async cancelRequest() {
      await fb.db
        .collection("appSupportRequests")
        .doc(this.currentItem.orderNumber)
        .update({
          status: "cancelled",
          cancelledBy: {
            name: `${this.user.firstName} ${this.user.lastName}`,
            email: `${this.user.email}`,
          },
        });
      this.cancelDialog = false;
      this.getAppSupportRequests();
    },
  },
};
</script>
